{
  "COMPOSE_REDIRECT": {
    "OPENING": "Відкриття нової розмови з {email}…",
    "NO_EMAIL": "Не вказано електронну адресу. Використовуйте ?email=name@example.com",
    "CONTACT_ERROR": "Не вдалося знайти контакт для {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Будь ласка, виберіть бесіду з лівої панелі",
    "CSAT_REPLY_MESSAGE": "Будь ласка, оцініть розмову",
    "404": "На жаль, не вдалося знайти розмову. Будь ласка, спробуйте ще раз",
    "SWITCH_VIEW_LAYOUT": "Змінити розкладку",
    "DASHBOARD_APP_TAB_MESSAGES": "Текст повідомлень",
    "UNVERIFIED_SESSION": "Користувач не верифікований",
    "NO_MESSAGE_1": "Ой! Схоже, у вашій поштовій скринці немає ніяких повідомлень.",
    "NO_MESSAGE_2": " щоб надіслати повідомлення на вашу сторінку!",
    "NO_INBOX_1": "Галас! Схоже, ви ще не додали скриньк.",
    "NO_INBOX_2": " для початку",
    "NO_INBOX_AGENT": "Ой! Схоже, ви не маєте доступу до скриньки \"Вхідні\". Будь ласка, зверніться до адміністратора",
    "SEARCH_MESSAGES": "Пошук повідомлень у розмовах",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Переклад",
    "EMPTY_STATE": {
      "CMD_BAR": "відкрити командне меню",
      "KEYBOARD_SHORTCUTS": "переглянути комбінації клавіш"
    },
    "SEARCH": {
      "TITLE": "Пошук повідомлень",
      "RESULT_TITLE": "Результати пошуку",
      "LOADING_MESSAGE": "Триває збір даних...",
      "PLACEHOLDER": "Введіть текст для пошуку повідомлень",
      "NO_MATCHING_RESULTS": "Результатів не знайдено."
    },
    "UNREAD_MESSAGES": "Непрочитані повідомлення",
    "UNREAD_MESSAGE": "Непрочитане повідомлення",
    "CLICK_HERE": "Натисніть тут",
    "LOADING_INBOXES": "Завантаження скриньок",
    "LOADING_CONVERSATIONS": "Завантаження бесід",
    "CANNOT_REPLY": "Ви не можете відповісти через",
    "24_HOURS_WINDOW": "24-годинне обмеження на повідомлення",
    "NOT_ASSIGNED_TO_YOU": "Ця розмова не призначена на вас. Ви бажаєте призначити цю розмову на себе?",
    "ASSIGN_TO_ME": "Призначити мені",
    "TWILIO_WHATSAPP_CAN_REPLY": "Ви можете відповісти на цю розмову тільки за допомогою шаблонного повідомлення через",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-годинне обмеження на повідомлення",
    "REPLYING_TO": "Ви відповідаєте:",
    "REMOVE_SELECTION": "Видалити вибране",
    "DOWNLOAD": "Звантажити",
    "UNKNOWN_FILE_TYPE": "Невідомий файл",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Перед надсиланням виконайте:",
      "EXECUTE": "Виконати",
      "RETRY": "Спробувати ще раз",
      "CONFIRM": "Виконати зараз?",
      "CONFIRM_YES": "Так, виконати",
      "CONFIRM_NO": "Скасувати",
      "RUNNING": "Виконується…",
      "DONE": "Виконано",
      "CLAIM_DELAYED": "буде оформлено після доставки замовлення",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Створено НОВУ претензію {reference}, {planned} закрита — змініть текст чернетки",
        "NEW_CLAIM": "Створено НОВУ претензію {reference} замість оновлення {planned} — змініть текст чернетки",
        "OTHER_CLAIM": "Оновлено претензію {reference} замість {planned} — змініть текст чернетки",
        "EXISTING_CLAIM": "Нову претензію не створено, оновлено наявну {reference} — змініть текст чернетки",
        "OTHER": "Все пройшло інакше, ніж припускала чернетка — змініть текст чернетки"
      },
      "FAILED": "Не вдалося",
      "UNREACHABLE": "Бот недоступний",
      "REQUEST_FAILED": "Не вдалося запустити дію, спробуйте ще раз.",
      "ACTIONS": {
        "CANCEL_ORDER": "Скасувати замовлення",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Змінити оплату на накладений платіж",
        "CREATE_CLAIM": "Оформити претензію",
        "CREATE_OR_UPDATE_CLAIM": "Оформити або оновити претензію",
        "EXTEND_ORDER_PICKUP_DATE": "Продовжити термін отримання"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Завантаження вкладень...",
    "REPLIED_TO_STORY": "Відповів(-ла) на вашу історію",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Це повідомлення не підтримується. Ви можете переглянути це повідомлення у додатку Facebook Messenger",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Це повідомлення не підтримується. Ви можете переглянути це повідомлення у додатку Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Повідомлення успішно видалено",
    "FAIL_DELETE_MESSSAGE": "Не вдалося видалити повідомлення! Спробуйте ще раз",
    "NO_RESPONSE": "Немає відповіді",
    "RESPONSE": "Response",
    "RATING_TITLE": "Оцінка",
    "FEEDBACK_TITLE": "Зворотній зв'язок",
    "REPLY_MESSAGE_NOT_FOUND": "Повідомлення недоступне",
    "CARD": {
      "SHOW_LABELS": "Показати мітки",
      "HIDE_LABELS": "Сховати мітки"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Вирішити",
      "REOPEN_ACTION": "Відкрити знову",
      "OPEN_ACTION": "Відкриті",
      "OPEN": "Ще",
      "CLOSE": "Закрити",
      "DETAILS": "подробиці",
      "SNOOZED_UNTIL": "Відкладено до",
      "SNOOZED_UNTIL_TOMORROW": "Відкладено до завтра",
      "SNOOZED_UNTIL_NEXT_WEEK": "Відкладено до наступного тижня",
      "SNOOZED_UNTIL_NEXT_REPLY": "Відкладено до наступної відповіді",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "пропущено",
        "DUE": "до"
      },
      "MORE": "Більше дій"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Позначити як \"В очікуванні\"",
      "SNOOZE_UNTIL": "Відкласти",
      "SNOOZE": {
        "TITLE": "Відкласти до",
        "NEXT_REPLY": "Наступна відповідь",
        "TOMORROW": "Завтра",
        "NEXT_WEEK": "Наступного тижня"
      },
      "RESOLVE_WITHOUT_CSAT": "Вирішити без CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Відкласти до",
      "APPLY": "Відкласти",
      "CANCEL": "Скасувати"
    },
    "PRIORITY": {
      "TITLE": "Пріоритет",
      "OPTIONS": {
        "NONE": "Нiчого",
        "URGENT": "Терміновий",
        "HIGH": "Високий",
        "MEDIUM": "Середній",
        "LOW": "Низький"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Нiчого",
        "INPUT_PLACEHOLDER": "Оберіть пріоритет",
        "NO_RESULTS": "Результатів не знайдено",
        "SUCCESSFUL": "Змінено пріоритет для бесід з ID {conversationId} на {priority}",
        "FAILED": "Не вдалося змінити пріоритет. Будь ласка, спробуйте ще раз."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Відкрити в новій вкладці",
      "COPY_LINK": "Копіювати посилання на розмову",
      "COPY_LINK_SUCCESS": "Посилання на розмову скопійовано в буфер обміну",
      "PENDING": "Позначити як \"В очікуванні\"",
      "RESOLVED": "Позначити як вирішене",
      "MARK_AS_UNREAD": "Позначити як непрочитане",
      "MARK_AS_READ": "Позначити як прочитане",
      "REOPEN": "Повторно відкрити розмову",
      "SNOOZE": {
        "TITLE": "Відкласти",
        "NEXT_REPLY": "До наступної відповіді",
        "TOMORROW": "До завтра",
        "NEXT_WEEK": "До наступного тижня"
      },
      "ASSIGN_AGENT": "Призначити агента",
      "ASSIGN_LABEL": "Призначити мітку",
      "AGENTS_LOADING": "Завантаження агентів...",
      "ASSIGN_TEAM": "Призначити команду",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Ідентифікатор розмови {conversationId} призначено для \"{agentName}\"",
          "FAILED": "Не вдалося призначити агента. Будь ласка, спробуйте ще раз."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Не вдалося призначити мітку. Будь-ласка, спробуйте ще раз."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Призначено команду \"#{team}\" до ID розмови {conversationId}",
          "FAILED": "Не вдалося призначити команду. Будь ласка, спробуйте ще раз."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Підпис повідомлення",
      "ENABLE_SIGN_TOOLTIP": "Увімкнути підпис",
      "DISABLE_SIGN_TOOLTIP": "Вимкнути підпис",
      "MSG_INPUT": "Shift + Enter для нового рядка. Для вибору швидкої відповіді, уведіть '/'.",
      "PRIVATE_MSG_INPUT": "Shift + Enter для нового рядка. Видиме лише для співробітників",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Не налаштовано підпис повідомлення, будь ласка, налаштуйте його в налаштуваннях профілю.",
      "CLICK_HERE": "Натисніть тут для оновлення",
      "WHATSAPP_TEMPLATES": "Шаблони Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-годинне вікно WhatsApp завершилося. Відповідайте шаблонним повідомленням.",
      "INSERT_SIGNATURE": "Вставити підпис у редактор",
      "SIGNATURE_PREVIEW_IMAGE": "(підпис із зображенням)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Здається, ваша відповідь написана мовою {draftLanguage}, але ця розмова ведеться мовою {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Перекласти",
      "REPLY": "Відповісти",
      "PRIVATE_NOTE": "Особиста нотатка",
      "SEND": "Надіслати",
      "CREATE": "Додати нотатку",
      "INSERT_READ_MORE": "Детальніше",
      "DISMISS_REPLY": "Відхилити відповідь",
      "REPLYING_TO": "Відповісти:",
      "TIP_FORMAT_ICON": "Показати текстовий редактор",
      "HEADING_LEVEL": {
        "LABEL": "Стиль тексту",
        "NORMAL": "Звичайний текст",
        "H1": "Заголовок 1",
        "H2": "Заголовок 2",
        "H3": "Заголовок 3"
      },
      "EDITOR": {
        "BOLD": "Жирний",
        "ITALIC": "Курсив",
        "UNDERLINE": "Підкреслений",
        "TEXT_COLOR": "Колір тексту",
        "BG_COLOR_LABEL": "Колір фону",
        "FONT_SIZE_LABEL": "Розмір шрифту",
        "FONT_SIZE": {
          "XS": "Малий",
          "SM": "Середньо-малий",
          "MD": "Стандартний",
          "LG": "Великий",
          "XL": "Дуже великий",
          "XXL": "Величезний"
        },
        "CODE": "Код",
        "LINK": "Додати або видалити посилання",
        "CREATE_LINK": "Створити посилання",
        "SAVE_LINK": "Зберегти",
        "CANCEL": "Скасувати",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Скасувати дію",
        "REDO": "Повторити дію",
        "BULLET_LIST": "Маркований список",
        "ORDERED_LIST": "Нумерований список",
        "BLOCKQUOTE": "Цитата",
        "H1": "Заголовок 1",
        "H2": "Заголовок 2",
        "H3": "Заголовок 3",
        "IMAGE_UPLOAD": "Завантажити зображення",
        "CLEAR_FORMATTING": "Очистити форматування",
        "COLOR": {
          "RED": "Червоний",
          "YELLOW": "Жовтий",
          "BLUE": "Синій",
          "ROSE_RED": "Рожево-червоний",
          "DEEP_CYAN": "Темно-бірюзовий",
          "ORANGE": "Помаранчевий",
          "PISTACHIO": "Фісташковий",
          "PURPLE": "Фіолетовий",
          "FUCHSIA": "Фуксія",
          "SILVER": "Срібний",
          "NAVY": "Темно-синій",
          "OLD_PINK": "Старий рожевий",
          "AQUA": "Бірюзовий",
          "BROWN": "Коричневий",
          "OLIVE": "Оливковий",
          "GOLD": "Золотий",
          "BEIGE": "Бежевий",
          "WINE": "Винний",
          "FOREST": "Лісовий зелений",
          "GREEN": "Зелений",
          "BLUE_GREY": "Синьо-сірий",
          "RUBY_RED": "Рубіново-червоний",
          "CHESTNUT_BROWN": "Каштановий",
          "ASH_GREY": "Попелясто-сірий"
        },
        "BG_COLOR": {
          "RED": "Червоний",
          "YELLOW": "Жовтий",
          "BLUE": "Синій",
          "ROSE_RED": "Рожево-червоний",
          "DEEP_CYAN": "Темно-бірюзовий",
          "ORANGE": "Помаранчевий",
          "PISTACHIO": "Фісташковий",
          "PURPLE": "Фіолетовий",
          "FUCHSIA": "Фуксія",
          "SILVER": "Срібний",
          "NAVY": "Темно-синій",
          "OLD_PINK": "Старий рожевий",
          "AQUA": "Бірюзовий",
          "BROWN": "Коричневий",
          "OLIVE": "Оливковий",
          "GOLD": "Золотий",
          "BEIGE": "Бежевий",
          "WINE": "Винний",
          "FOREST": "Лісовий зелений",
          "GREEN": "Зелений",
          "BLUE_GREY": "Синьо-сірий",
          "RUBY_RED": "Рубіново-червоний",
          "CHESTNUT_BROWN": "Каштановий",
          "ASH_GREY": "Попелясто-сірий"
        }
      },
      "TIP_EMOJI_ICON": "Показати емодзі",
      "TIP_ATTACH_ICON": "Прикріпити файли",
      "TIP_AUDIORECORDER_ICON": "Записати аудіо",
      "TIP_AUDIORECORDER_PERMISSION": "Надати доступ до аудіо",
      "TIP_AUDIORECORDER_ERROR": "Не вдалося відкрити аудіо",
      "DRAG_DROP": "Перетягніть сюди, щоб прикріпити",
      "START_AUDIO_RECORDING": "Почати аудіозапис",
      "STOP_AUDIO_RECORDING": "Зупинити аудіозапис",
      "": "",
      "EMAIL_HEAD": {
        "TO": "На",
        "ADD_BCC": "Додати bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Адреси електронної пошти, розділені комами",
          "ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
        },
        "BCC": {
          "LABEL": "Прихована копія",
          "PLACEHOLDER": "Адреси електронної пошти, розділені комами",
          "ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
        },
        "EDIT": "Редагувати",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Приховати",
        "INCLUDE_ORIGINAL_MESSAGE": "Включити оригінальне повідомлення",
        "EDIT_HEADERS": "Редагувати",
        "HIDE_HEADER_EDITS": "Приховати зміни",
        "SUBJECT": {
          "LABEL": "ТЕМА",
          "PLACEHOLDER": "Тема email",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Невизначені змінні",
        "MESSAGE": "У вас є {undefinedVariablesCount} невизначених змінних у вашому повідомленні: {undefinedVariables}. Бажаєте надіслати повідомлення в будь-якому випадку?",
        "CONFIRM": {
          "YES": "Надіслати",
          "CANCEL": "Скасувати"
        }
      },
      "SEND_EMAIL": "Надіслати email",
      "SEND_SMS": "Надіслати SMS",
      "NO_SMS_INBOX": "Додайте SMS-інбокс, щоб надсилати відповіді через SMS.",
      "SEND_CHAT": "Надіслати чат",
      "REPLY_TO_THIS": "Відповісти на це",
      "TIP_EXPAND_ICON": "Збільшити редактор",
      "TIP_COLLAPSE_ICON": "Зменшити редактор",
      "COPILOT": {
        "Q": "Запитати робота про допомогу"
      }
    },
    "VISIBLE_TO_AGENTS": "Приватна нотатка: видима тільки вам та вашій команді",
    "CHANGE_STATUS": "Статус бесіди змінено",
    "CHANGE_STATUS_FAILED": "Не вдалося змінити статус розмови",
    "CHANGE_AGENT": "Оператора бесіди змінено",
    "CHANGE_AGENT_FAILED": "Не вдалося змінити виконавця",
    "ASSIGN_LABEL_SUCCESFUL": "Мітка успішно призначена",
    "ASSIGN_LABEL_FAILED": "Призначення мітки не вдалося",
    "CHANGE_TEAM": "Команда змінена",
    "FILE_SIZE_LIMIT": "Файл перевищує максимальний розмір вкладень {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} МБ",
    "MESSAGE_ERROR": "Не вдалося надіслати повідомлення, будь ласка, повторіть спробу пізніше",
    "SENT_BY": "Надіслав:",
    "BOT": "Бот",
    "SEND_FAILED": "Не вдалося надіслати повідомлення! Повторіть спробу",
    "TRY_AGAIN": "повторити",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Виберіть агента",
      "REMOVE": "Видалити",
      "ASSIGN": "Призначити"
    },
    "CONTEXT_MENU": {
      "COPY": "Копіювати",
      "REPLY_TO": "Відповісти на це повідомлення",
      "DELETE": "Видалити",
      "CREATE_A_CANNED_RESPONSE": "Додати швидку відповідь",
      "TRANSLATE": "Перекласти",
      "COPY_PERMALINK": "Копіювати посилання на повідомлення",
      "LINK_COPIED": "URL повідомлення скопійовано до буфера обміну",
      "DELETE_CONFIRMATION": {
        "TITLE": "Ви справді бажаєте вилучити це повідомлення?",
        "MESSAGE": "Ви не зможете скасувати цю дію",
        "DELETE": "Видалити",
        "CANCEL": "Скасувати"
      },
      "FORWARD": "Переслати",
      "FORWARD_ERROR": "Не вдалося підготувати переслане повідомлення"
    },
    "SIDEBAR": {
      "CONTACT": "Контакт",
      "COPILOT": "Copilot"
    },
    "IMAGE_RESIZE": {
      "SMALL": "Малий",
      "MEDIUM": "Середній",
      "LARGE": "Великий",
      "ORIGINAL": "Оригінал"
    },
    "SHOW_HIDDEN_MESSAGES": "Показати приховані повідомлення",
    "TRANSCRIPT": {
      "SHOW": "Показати повну стенограму",
      "HIDE": "Приховати повну стенограму",
      "DOWNLOAD": "Завантажити стенограму",
      "COPY": "Копіювати стенограму"
    },
    "INVISIBLE_TO_CUSTOMER": "Невидимо для клієнта",
    "SENT_VIA_EMAIL": "Також надіслано контакту електронною поштою ({time})",
    "API_HOURS_WINDOW": "Ви можете відповідати на цю розмову лише протягом {hours} годин",
    "FACEBOOK_CANNOT_REPLY": "Якщо вам потрібно продовжити цю розмову, ",
    "PENDING_WITH_BOT_BANNER": "Цю розмову обробляє ШІ-бот. Якщо ви хочете відповісти, спочатку відкрийте розмову.",
    "INBOX_DELETE_REQUESTED_BANNER": "Цей інбокс позначено для видалення, тому відповідь клієнта ніколи не дійде. Щоб відповісти, перемістіть розмову в інший інбокс.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "У цього контакту є інша відкрита бесіда #{id}",
      "MULTIPLE": "У цього контакту є інші відкриті бесіди ({count})",
      "OPEN": "Відкрити",
      "SHOW": "Показати"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Цей обліковий запис Instagram було перенесено до нового інбоксу каналу Instagram. Усі нові повідомлення з'являтимуться там. Ви більше не зможете надсилати повідомлення з цієї розмови.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Неможливо надіслати повідомлення, оскільки клієнт не онлайн, а безперервність електронної пошти недоступна.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Клієнт не онлайн. Він може не отримати повідомлення, оскільки безперервність електронної пошти недоступна.",
    "OPEN_FILE": "Відкрити",
    "DOWNLOAD_ATTACHMENTS": "Завантажити все",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Завантажити всі вкладення по одному",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Завантажити все як ZIP",
    "ERROR_DOWNLOADING_FILE": "Помилка завантаження файлу",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Попросити клієнта поділитися номером телефону WhatsApp",
      "PENDING_ACTION": "Запит на контактні дані очікує",
      "STATES": {
        "PENDING": "Очікування контактних даних",
        "SHARED": "Номер телефону надано",
        "IDENTITY_CONFLICT": "Номер телефону потребує перевірки"
      }
    },
    "SLA": {
      "BREACHED": "порушено"
    },
    "IMAGE_UPLOAD_ERROR": "Не вдалося завантажити зображення, спробуйте ще раз",
    "DRAFT": {
      "FILE_TOO_LARGE": "Файл '{fileName}' ({fileSize}) занадто великий для зберігання у чернетці і буде пропущений",
      "ATTACHMENT_SERIALIZATION_FAILED": "Не вдалося серіалізувати вкладення для зберігання у чернетці",
      "STORAGE_QUOTA_EXCEEDED": "Перевищено квоту сховища. Чернетку збережено без вкладень",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Не вдалося зберегти чернетку навіть без вкладень",
      "SAVE_FAILED": "Не вдалося зберегти чернетку розмови"
    },
    "COMMENT_TREE": {
      "TITLE": "Гілка коментарів",
      "EMPTY": "Немає коментарів для відображення",
      "VIEW_TREE": "Переглянути гілку коментарів"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Розмова була відмічена як вирішена {userName}",
          "CONTACT_RESOLVED": "Діалог був закритий {contactName}",
          "OPEN": "Розмову знову відкрито {userName}",
          "PENDING": "Бесіда була позначена як очікується {userName}",
          "SNOOZED": "Розмова була відкладена {userName}",
          "AUTO_RESOLVED": "Діалог був закритий системою через {duration} днів неактивності",
          "SYSTEM_AUTO_OPEN": "Система повторно відкрила розмову через нове вхідне повідомлення.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Розмова позначена як вирішена {userName} (без CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Розмова була позначена як вирішена системою через {duration} годин неактивності",
          "AUTO_RESOLVED_EMPTY": "Розмова позначена як вирішена системою, оскільки була порожньою.",
          "BLOCKED_CONTACT_RESOLVED": "Система вирішила розмову, оскільки контакт заблокований.",
          "KAUFLAND_TICKET_CLOSED": "Система вирішила розмову, оскільки тікет закрито на Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} встановив пріоритет {newPriority}",
          "UPDATED": "{userName} змінив пріоритет з {oldPriority} на {newPriority}",
          "REMOVED": "{userName} видалив пріоритет"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} самостійно призначив цей діалог",
          "ASSIGNED": "Призначено до {assigneeName} користувачем {userName}",
          "REMOVED": "Діалог знято {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Призначено до {teamName} користувачем {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Призначено до {assigneeName} користувачем {userName} з {teamName}",
          "REMOVED": "Виключений з {teamName} користувачем {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} додав {labels}",
          "REMOVED": "{userName} видалив {labels}"
        },
        "SLA": {
          "ADDED": "{userName} додав політику SLA {slaName}",
          "REMOVED": "{userName} видалив політику SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} включив безвучний режим",
        "UNMUTED": "{userName} виключив безвучний режим",
        "CONTACT_BLOCKED": "{userName} заблокував(ла) контакт",
        "CONTACT_UNBLOCKED": "{userName} розблокував(ла) контакт",
        "AUTO_RESOLUTION_MESSAGE": "Закриваю розмову, оскільки вона деякий час була неактивною. Будь ласка, почніть нову розмову, якщо вам потрібна додаткова допомога.",
        "DOMAIN_BLOCKED": "{userName} заблокував усі контакти для цього домену",
        "DOMAIN_UNBLOCKED": "{userName} розблокував усі контакти для цього домену",
        "MERGED": "{userName} обʼєднав розмову #{sourceId} у цю розмову",
        "MOVED": "{userName} перемістив цю розмову зі скриньки {sourceInboxName} до скриньки {targetInboxName}",
        "MOVED_BY_ORDER": "Переміщено, оскільки замовлення контакту є лише в магазині {storeName} (останнє замовлення {orderId}), робот якого відповідає в цій скриньці.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Дію надсилання повідомлення було пропущено для цієї автовідповіді",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Автоматизацію пропущено, оскільки контакт заблоковано",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Автоматизація \"{ruleName}\" не змогла перемістити цю розмову з інбоксу {sourceInboxName} до інбоксу {targetInboxName}, оскільки інбокси несумісні.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Автоматизація \"{ruleName}\" не змогла перемістити цю розмову з інбоксу {sourceInboxName} до інбоксу {targetInboxName}, оскільки контакт не має адреси електронної пошти.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Автоматизація «{ruleName}» не змогла надіслати повідомлення: цей телефонний інбокс не може надсилати SMS, оскільки в акаунті немає SMS-інбоксу. Правило вимкнено, адміністратори отримали лист.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Автоматизація «{ruleName}» не змогла надіслати повідомлення: з цього інбоксу не можна надсилати вкладення по SMS. Правило вимкнено, адміністратори отримали лист.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Макрос «{macroName}» не надіслав повідомлення: цей телефонний інбокс не може надсилати SMS, оскільки в акаунті немає SMS-інбоксу.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Макрос «{macroName}» не надіслав повідомлення: з цього інбоксу не можна надсилати вкладення по SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Макрос «{macroName}» не надіслав повідомлення: цю розмову обробляє бот. Спершу відкрийте розмову.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Макрос «{macroName}» не надіслав повідомлення: цей інбокс позначено для видалення. Спершу перемістіть розмову в інший інбокс.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Автоматизація \"{ruleName}\" надіслала лист на {contactEmail} у новій розмові [#{conversationId}]({conversationPath}) в інбоксі {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Автоматизація \"{ruleName}\" почала цю розмову через розмову [#{conversationId}]({conversationPath}) в інбоксі {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Автоматизація \"{ruleName}\" не змогла надіслати повідомлення в новій розмові в інбоксі {inboxName}, оскільки контакт не має адреси електронної пошти.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Автоматизація \"{ruleName}\" надіслала SMS на {contactPhone} у новій розмові [#{conversationId}]({conversationPath}) в інбоксі {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Автоматизація \"{ruleName}\" не змогла надіслати SMS у новій розмові в інбоксі {inboxName}, оскільки контакт не має номера телефону.",
        "AUTOMATION_RULE_TRIGGERED": "Правило автоматизації \"{ruleName}\" запущено",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Правило автоматизації \"{ruleName}\" вимкнуло автоматичний пріоритет",
        "AUTOMATION_SKIP_AUTO_LABELING": "Правило автоматизації \"{ruleName}\" вимкнуло автоматичне маркування",
        "AUTOMATION_STOP_PROCESSING_RULES": "Правило автоматизації \"{ruleName}\" зупинило подальшу обробку правил",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Агент",
            "CUSTOMER": "Клієнт"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "відповіли деінде, дзвонило {duration}",
            "NO_ANSWER": "без відповіді, дзвонило {duration}",
            "REJECTED": "відхилено, дзвонило {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Автоматично вирішено після невдалих передзвонів: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Запис дзвінка видалено користувачем {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Надіслати стенограму розмови",
    "DESC": "Відправте копію стенограми розмови на вказану адресу електронної пошти",
    "SUBMIT": "Додати",
    "CANCEL": "Скасувати",
    "SEND_EMAIL_SUCCESS": "Текст розмови надісланий",
    "SEND_EMAIL_ERROR": "Сталася помилка, будь ласка, спробуйте ще раз",
    "FORM": {
      "SEND_TO_CONTACT": "Надіслати клієнту стенограму",
      "SEND_TO_AGENT": "Надіслати стенограму агенту",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Відправити стенограму на іншу електронну адресу",
      "EMAIL": {
        "PLACEHOLDER": "Введіть адресу електронної пошти",
        "ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Привіт, 👋, Ласкаво просимо на {installationName}!",
    "DESCRIPTION": "Дякуємо за реєстрацію. Ми хочемо отримати максимум від {installationName}. Ось кілька речей, які ви можете зробити в {installationName}, щоб отримати приємний досвід.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Читати наші останні оновлення",
    "ALL_CONVERSATION": {
      "TITLE": "Всі ваші розмови в одному місці",
      "DESCRIPTION": "Переглядайте всі розмови з Ваших клієнтів в одній панелі. Ви можете фільтрувати розмови за допомогою каналу, міток та статусу.",
      "NEW_LINK": "Натисніть тут, щоб створити вхідний канал"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Запросити членів команди",
      "DESCRIPTION": "Оскільки Ви готуєтеся поговорити зі своїм клієнтом, запросіть ваших партнерів по команді, щоб допомогти вам. Ви можете запросити ваших товаришів по команді, додавши їх адреси електронної пошти до списку співробітників.",
      "NEW_LINK": "Натисніть тут, щоб запросити учасника"
    },
    "LABELS": {
      "TITLE": "Організувуйте бесіди за допомогою міток",
      "DESCRIPTION": "Мітки забезпечують простіший спосіб вести категоризацію ваших розмов. Створіть деякі мітки, такі як #support-enquy, #billing-question і т. п., щоб ви могли використовувати їх в розмовах пізніше.",
      "NEW_LINK": "Натисніть тут, щоб створити мітки"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Призначений агент",
    "SELF_ASSIGN": "Призначити мені",
    "TEAM_LABEL": "Призначена команда",
    "SELECT": {
      "PLACEHOLDER": "Нiчого"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Власні дані",
      "CONTACT_DETAILS": "Контактні дані",
      "CONVERSATION_ACTIONS": "Дії при бесіді",
      "CONVERSATION_LABELS": "Мітки бесіди",
      "CONVERSATION_INFO": "Інформація про бесіду",
      "CONTACT_ATTRIBUTES": "Атрибути контакту",
      "PREVIOUS_CONVERSATION": "Попередні бесіди",
      "MACROS": "Макрос",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Історія замовлень",
      "RETINO_TICKETS": "Тікети Retino"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Очікує",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Створити атрибут",
    "NO_RECORDS_FOUND": "Атрибути не знайдено",
    "UPDATE": {
      "SUCCESS": "Атрибут успішно оновлено",
      "ERROR": "Не вдалося оновити атрибут. Будь ласка, спробуйте ще раз пізніше"
    },
    "ADD": {
      "TITLE": "Додати",
      "SUCCESS": "Атрибут додано успішно",
      "ERROR": "Неможливо додати атрибут. Будь ласка, спробуйте ще раз пізніше"
    },
    "DELETE": {
      "SUCCESS": "Атрибут успішно видалено",
      "ERROR": "Неможливо видалити атрибут. Будь ласка, спробуйте ще раз пізніше"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Додати атрибут",
      "PLACEHOLDER": "Атрибути пошуку",
      "NO_RESULT": "Атрибути не знайдено"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Від",
    "TO": "Для",
    "BCC": "Прихована копія",
    "CC": "Копія",
    "SUBJECT": "Тема"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Підключені агенти",
    "SIDEBAR_TITLE": "Учасники бесіди",
    "NO_RECORDS_FOUND": "Результатів не знайдено",
    "ADD_PARTICIPANTS": "Виберіть учасників",
    "REMANING_PARTICIPANTS_TEXT": "+{count} інших",
    "REMANING_PARTICIPANT_TEXT": "+{count} інших",
    "TOTAL_PARTICIPANTS_TEXT": "{count} людей беруть участь.",
    "TOTAL_PARTICIPANT_TEXT": "{count} людей беруть участь.",
    "NO_PARTICIPANTS_TEXT": "Нікого немає!.",
    "WATCH_CONVERSATION": "Підключитись до бесіди",
    "YOU_ARE_WATCHING": "Ви підключились",
    "API": {
      "ERROR_MESSAGE": "Не вдалося оновити, спробуйте ще раз!",
      "SUCCESS_MESSAGE": "Учасники оновлені!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Переглянути переклад",
    "DESC": "Ви можете переглянути переклад контент в кожній мові.",
    "ORIGINAL_CONTENT": "Оригінальний текст",
    "TRANSLATED_CONTENT": "Переклад",
    "NO_TRANSLATIONS_AVAILABLE": "Немає доступних перекладів"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Хтось друкує"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Дані не знайдено",
    "LOAD_ERROR": "Не вдалося завантажити дані. Спробуйте пізніше."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Завантажити ще",
    "NO_RECORDS_FOUND": "Тікетів не знайдено",
    "LOAD_ERROR": "Не вдалося завантажити тікети з {hookName}. Будь ласка, спробуйте пізніше.",
    "NOT_SEARCHABLE": "Email контакту не встановлено.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Завантаження...",
    "NO_ORDERS": "Замовлень не знайдено",
    "NOT_AVAILABLE": "Дані клієнта недоступні",
    "EXPAND": "Відкрити профіль клієнта",
    "MORE_ITEMS": "+ {count} товарів",
    "EXPEDITION_STATUS": "Статус відправлення",
    "OPEN_DETAIL": "відкрити деталі",
    "COPY_ORDER_ID": "Номер замовлення",
    "EXTERNAL_ID": "Зовнішній ID",
    "PAYMENT_TYPE": "Спосіб оплати",
    "PAYMENT_DATE": "Дата оплати",
    "DELIVERY_PROVIDER": "Перевізник",
    "EXPECTED_DATE_OF_DELIVERY": "Очікувана доставка",
    "DATE_OF_DELIVERY": "Доставлено",
    "EXPEDITION_DATE": "Дата відправлення",
    "INTERNAL_NOTE": "Примітка магазину",
    "PACKAGE_NUMBER": "Відправлення"
  },
  "READING": {
    "ONE": "{user} читає цей тікет",
    "TWO": "{user} та {secondUser} читають цей тікет",
    "MULTIPLE": "{user} та ще {count} читають цей тікет"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Перемістити розмову",
    "DESCRIPTION": "Перемістіть цю розмову до іншого email-інбоксу.",
    "SOURCE": {
      "TITLE": "Розмова",
      "ID_LABEL": "ID розмови"
    },
    "TARGET": {
      "TITLE": "Цільовий інбокс",
      "PLACEHOLDER": "Виберіть email-інбокс",
      "NO_RESULTS": "Немає інших доступних email-інбоксів",
      "ERROR": "Будь ласка, виберіть цільовий інбокс"
    },
    "SUBMIT": "Перемістити розмову",
    "CANCEL": "Скасувати",
    "SUCCESS_MESSAGE": "Розмову успішно переміщено",
    "ERROR_MESSAGE": "Не вдалося перемістити розмову. Будь ласка, спробуйте ще раз."
  },
  "MERGE": {
    "TITLE": "Об'єднати розмови",
    "DESCRIPTION": "Об'єднайте цю розмову з іншою розмовою. Усі повідомлення з цієї розмови буде переміщено до цільової розмови, а цю розмову буде видалено.",
    "SOURCE": {
      "TITLE": "Вихідна розмова (буде видалена)",
      "ID_LABEL": "ID розмови"
    },
    "TARGET": {
      "TITLE": "Цільова розмова",
      "PLACEHOLDER": "Введіть ID розмови для пошуку (наприклад, 123)",
      "HELP": "Введіть ID розмови, до якої буде об'єднано всі повідомлення.",
      "ERROR": "Будь ласка, виберіть цільову розмову"
    },
    "WARNING": "Увага: цю дію неможливо скасувати. Усі повідомлення буде переміщено до цільової розмови, а цю розмову буде остаточно видалено.",
    "SUBMIT": "Об'єднати розмови",
    "CANCEL": "Скасувати",
    "SUCCESS_MESSAGE": "Розмову успішно об'єднано",
    "ERROR_MESSAGE": "Не вдалося об'єднати розмови. Перевірте цільову розмову та спробуйте ще раз.",
    "SEARCH": {
      "NO_RESULTS": "Розмову з таким ID не знайдено",
      "ERROR_MESSAGE": "Не вдалося знайти розмови. Будь ласка, спробуйте ще раз."
    },
    "CONFIRM": {
      "TITLE": "Підтвердження об'єднання",
      "DESCRIPTION": "Ви впевнені, що хочете об'єднати цю розмову? Цю дію неможливо скасувати.",
      "YES": "Так, об'єднати",
      "CANCEL": "Скасувати"
    }
  }
}
